// Non-sensitive marker indicating an authenticated session exists.
//
// The JWT itself lives in an httpOnly cookie and is never readable by JS.
// Some non-React API modules (e.g. serviceApi) use this flag only to decide
// which endpoint variant to call (admin vs public). It carries no secret.
//
// "Remember me" → localStorage (survives browser restart)
// otherwise     → sessionStorage (cleared when the tab closes)

const AUTH_FLAG_KEY = 'auth:session';

export const setAuthFlag = (rememberMe: boolean): void => {
  clearAuthFlag();
  const storage = rememberMe ? window.localStorage : window.sessionStorage;
  storage.setItem(AUTH_FLAG_KEY, '1');
};

export const clearAuthFlag = (): void => {
  window.localStorage.removeItem(AUTH_FLAG_KEY);
  window.sessionStorage.removeItem(AUTH_FLAG_KEY);
};

export const isAuthFlagSet = (): boolean => {
  try {
    return (
      window.localStorage.getItem(AUTH_FLAG_KEY) === '1' ||
      window.sessionStorage.getItem(AUTH_FLAG_KEY) === '1'
    );
  } catch {
    return false;
  }
};
